import { FC } from 'react';
import { GuestBarLayout } from './layout/GuestBarLayout';
import { GuestCounter } from './content/GuestCounter';
import { GuestBarLabel } from './content/GuestBarLabel';
import { AssetVisibility } from '@cld/unicorn-api';

export interface StatelessGuestBarProps {
  remainingSeconds: number | null;
  onTimerClick: () => void;
  onEyeButtonClick?: () => void;
  assetViewMode: AssetVisibility;
  isMobile: boolean;
  showEyeButton: boolean;
}

export const StatelessGuestBar: FC<StatelessGuestBarProps> = ({
  remainingSeconds,
  onEyeButtonClick,
  onTimerClick,
  assetViewMode,
  showEyeButton,
  ...rest
}) => (
  <GuestBarLayout
    data-test="guest-bar"
    slot1={<GuestBarLabel data-test-specifier="guest-label" />}
    slot2={<GuestCounter data-test-specifier="guest-counter" remainingSeconds={remainingSeconds} onClick={onTimerClick} />}
    slot3={null}
    // TODO: enable once implementing asset view
    // slot3={showEyeButton && <EyeButton data-test-specifier="eye-button" viewMode={assetViewMode} onClick={onEyeButtonClick} />}
    {...rest}
  />
);
